import axios from '@axios';

const base = '/api/v1/prisons';

export default {
  getPrison() {
    return axios.get(`${base}/prison`);
  },
};
